import { HierarchyUtils, ComponentIds, Entity } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { PlacementResult } from '@inter-ikea-core/core';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import { getRange } from 'utils/queryUtils';
import {
  hideNoDoorsInSceneErrorMessage,
  hideNoFramesInSceneErrorMessage
} from '../rules/hideMenuRules';
import { hidePlatsaAddingFrontToOpenFrameErrorMessage } from 'rangeConfig/platsa/rules/hideMenuRules';
import {
  hidePaxDoorHandlesOnCornerSolutionErrorMessage,
  hidePaxDoorHandlesOnDoorsMixedIncludedIntegratedHandles,
  hidePaxHandlesNotApplicableOnDoorsWithIntegratedHandles,
  hidePaxHandlesNotApplicableOnSlidingDoors
} from 'rangeConfig/pax/rules/hideMenuRules';

const autoFillHandlesBehavior = ({ coreApi, props }: BehaviorParameters) => {
  const selectedEntity = props.position
    ? coreApi.entities.getEntityClosestToPosition(props.position, [
        ComponentIds.DOOR_COMPONENT_ID,
        ComponentIds.DRAWER_COMPONENT_ID
      ])
    : coreApi.entities.findSelectedEntity();
  let targets: Entity[];

  let oldHandles: Entity[] = [];
  if (selectedEntity) {
    oldHandles = HierarchyUtils.descendants(selectedEntity).filter((child: Entity) =>
      child.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)
    );
    targets = [selectedEntity];
  } else {
    oldHandles = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
    targets = coreApi.entities.getByComponents([
      ComponentIds.DOOR_COMPONENT_ID,
      ComponentIds.DRAWER_COMPONENT_ID
    ]);
  }

  const placementResults = coreApi.products.autoFillHandles(
    props.coreProductId,
    oldHandles,
    targets
  );

  const determinePlacementAttemptErrorMessage = () => {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (!hidePlatsaAddingFrontToOpenFrameErrorMessage(coreApi)) {
      return ErrorMessages.PlatsaAddingHandlesToOpenFrames;
    } else if (!hideNoDoorsInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoDoorsInScene;
    } else if (
      !hidePaxDoorHandlesOnCornerSolutionErrorMessage(coreApi, selectedEntity || undefined)
    ) {
      return ErrorMessages.PaxDoorHandlesOnCornerSolution;
    } else if (!hidePaxHandlesNotApplicableOnSlidingDoors(coreApi)) {
      return ErrorMessages.PaxDoorHandlesOnSlidingDoors;
    } else if (!hidePaxHandlesNotApplicableOnDoorsWithIntegratedHandles(coreApi)) {
      return ErrorMessages.PaxDoorHandlesOnDoorsIntegratedHandles;
    } else if (!hidePaxDoorHandlesOnDoorsMixedIncludedIntegratedHandles(coreApi)) {
      return ErrorMessages.PaxDoorHandlesOnDoorsMixedIncludedIntegratedHandles;
    } else if (
      getRange() === 'platsa' &&
      placementResults.find(
        result =>
          !result.valid &&
          result.errors.find(e => (e as any).message === 'Found no snap action candidates')
      )
    ) {
      return ErrorMessages.HandlesTooBigForDoor;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  placementResults.forEach((result: PlacementResult) => {
    if (!result.valid && result.errors && result.errors.length > 0) {
      coreApi.entities.disposeCollidingEntities(result.errors);
    }
  });
  placementResults.some((result: PlacementResult) => result.valid);
};

export default autoFillHandlesBehavior;
